import React from 'react';
import {Button, Icon, message, Spin, Table} from 'antd/lib/index';
import WebServerRestClient from "../../tools/WebServerRestClient";
import UserComponent from "../../components/UserComponent";

export default class MonitorServerList extends UserComponent {

    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            totalCount: 0,
            currentPage: 1,
            pageSize: 10,
            filteredInfo: null,
            sortedInfo: null,
        }
    }

    componentDidMount() {
        this.loadListData();
    }


    loadListData() {
        this.setState({loading: true});
        new WebServerRestClient().GET('/admin/redis/values/monitor_servers_status')
            .then(response => {
                console.log("query cache [monitor_servers_status] response -> " + response.code);
                this.setState({loading: false});
                if (response.code === 200) {
                    let totalCount = 0;
                    if (response.data) {
                        totalCount = response.data.length;
                    }
                    this.setState({dataList: response.data, totalCount: totalCount, loading: false})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            this.setState({loading: false});
            message.error("Error: " + err.message);
        });
    }

    handleChange = (pagination, filters, sorter) => {
        console.log('Various parameters', pagination, filters, sorter);
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    };

    refreshServers(){
        this.setState({doing: true});
        new WebServerRestClient().POST('/admin/network/refresh-servers')
            .then(response => {
                console.log("refresh-servers response -> " + JSON.stringify(response));
                this.setState({doing: false});
                if (response.code === 200) {
                    this.loadListData();
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            this.setState({doing: false});
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    render() {
        let { sortedInfo } = this.state;
        sortedInfo = sortedInfo || {};
        return (
            <div className="container">
                <div className="toolbar">
                    <Button type="primary" icon="download" onClick={this.refreshServers.bind(this)} loading={this.state.doing}>
                        Refresh
                    </Button>
                </div>

                <div className="total_bar">
                    <span className="right">total of <b style={{color:'red'}}>{this.state.totalCount}</b> records</span>
                </div>

                <Table loading={this.state.loading}
                       rowKey={'key'}
                       columns={[
                           {title: 'Key', dataIndex: 'key', align: 'left'},
                           {title: 'Type', dataIndex: 'type', align: 'center',
                               sorter: (a, b) => a.type.length - b.type.length,
                               sortOrder: sortedInfo.columnKey === 'type' && sortedInfo.order
                           },
                           {title: 'Continent', dataIndex: 'continent_code', align: 'center'},
                           {title: 'Country', dataIndex: 'country_code', align: 'center'},
                           {title: 'IP', dataIndex: 'ip', align: 'left'},
                           {title: 'Port', dataIndex: 'port', align: 'center'},
                           {
                               title: 'Status', dataIndex: 'alive', align: 'center',
                               render: (value) => {
                                   if (value == true) {
                                       return <span style={{color: 'green', fontWeight: 'bold', fontSize: 12}}>ACTIVE</span>
                                   } else if (value === false) {
                                       return <span style={{color: 'red', fontWeight: 'bold', fontSize: 12}}>DOWN</span>
                                   }
                               },
                               sorter: (a, b) => a.alive - b.alive,
                               sortOrder: sortedInfo.columnKey === 'alive' && sortedInfo.order
                           }
                       ]}
                       onChange={this.handleChange}
                       dataSource={this.state.dataList}
                       pagination={false}/>
            </div>
        )
    }

}
